import { ChangeDetectorRef, Component, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ColDef } from 'ag-grid-community';
import { ConfirmationMessageComponent } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/components/confirmation-message/confirmation-message.component';
import { DatosExcel } from 'src/app/shared/ExportadorFicheros/models/datos-excel';
import { DatosPdf } from 'src/app/shared/ExportadorFicheros/models/datos-pdf';
import { ExportadorExcelService } from 'src/app/shared/ExportadorFicheros/services/exportador-excel.service';
import { ExportadorPdfService } from 'src/app/shared/ExportadorFicheros/services/exportador-pdf.service';
import { FiltroBasico } from 'src/app/shared/models/filtros';
import { CentrosModel } from '../../models/centros-model';
import { GridColDefsCentros } from '../../models/grid-col-defs-centros';
import { DatosCentrosService } from '../../services/datos-centros.service';
import { CentrosBarraSuperiorComponent } from '../centros-barra-superior/centros-barra-superior.component';
import { CentrosModalComponent } from '../centros-modal/centros-modal.component';
import { EmpresasModel } from '../../../empresas/models/empresas-model';
import { RecuperaEmpresasApiService } from '../../../empresas/services/recupera-empresas-api.service';
import { RecuperaEmpresasMockService } from '../../../empresas/services/recupera-empresas-mock.service';
import { ModalMessageComponent } from 'src/app/shared/components/modals/modal-message/modal-message.component';
import { SpinnerModalComponent } from 'src/app/shared/components/others/spinner-modal/spinner-modal.component';
import { TipoMensajeConfirmacion } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/models/confirmation-message-data';
import { DatosEmpresasService } from '../../../empresas/services/datos-empresas.service';
import { OrdenColumna } from 'src/app/shared/models/orden-columna';
import { SqpGridComponentComponent } from 'src/app/shared/components/sqp-components/sqpGrid/sqp-grid-component/sqp-grid-component.component';
import { PaginationHelperService } from 'src/app/shared/services/pagination-helper.service';
import { SpinnerModalSqpComponent } from 'src/app/shared/components/sqp-components/sqpModales/spinner-modal-sqp/spinner-modal-sqp.component';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-centros-page',
  templateUrl: './centros-page.component.html',
  styleUrls: ['./centros-page.component.css']
})
export class CentrosPageComponent implements OnInit {

  centros: any[];
  empresas: EmpresasModel[]=[];
  filtros: FiltroBasico[] = [];
  columnDefs: ColDef[] = new GridColDefsCentros().columnDefs;
  mostrarSubidaExcel: boolean = false;
  centrosSeleccionados: CentrosModel[] = [];
  textoBorrar: string = '';

  currentPage = 1;
  hasMoreRows = true;
  isLoading = false;
  dialogRefSpinner: any;
  ordenColumna: OrdenColumna;
  // newRows: CentrosModel[] = [];
  // centrosFiltradosInput: CentrosModel[] = [];
  gridOptions:any={
    suppressScrollOnNewData: true
  }
  @ViewChild(SqpGridComponentComponent) sqpGrid: SqpGridComponentComponent;
  gridSuppressSelectionEvents: boolean = false;
  // searchTimeout: any;
  // @ViewChild(CentrosBarraSuperiorComponent) barrSuperior!: CentrosBarraSuperiorComponent;

  constructor(public datosCentrosService: DatosCentrosService,
              private _snackBar: MatSnackBar,
              public dialog: MatDialog,
              private exportadorPdfService: ExportadorPdfService,
              private exportadorExcelService: ExportadorExcelService,
              private datosEmpresasService: DatosEmpresasService,
              private cdRef: ChangeDetectorRef,
              private paginationHelper: PaginationHelperService) { }

  ngOnInit() {
    this.filtros.push({ text: '',textoBuscar: '',value: ''});
    this.reloadData();
    this.getEmpresas();
  }

  getCentros(origen: string, closeSpinner: boolean = true){
    this.isLoading = true;
    this.datosCentrosService.getCentros(this.filtros, this.currentPage, this.ordenColumna)
      .pipe(finalize(() => {
        this.isLoading = false;
      })).subscribe({
        next: (response: CentrosModel[]) => {

          this.centros = [...this.centros,...response];
          this.currentPage++;
          const returnedRowCount = response.length;
          if (returnedRowCount < 50) this.hasMoreRows = false;
          else this.hasMoreRows = true;

          this.isLoading = false;

          // Re-select previously selected rows after rows are rendered (only if not loading all rows)
          this.cdRef.detectChanges();
          requestAnimationFrame(() => {
            // Only re-select if we're not in the middle of loading all rows
            if (closeSpinner) {
              this.selectPreviouslySelectedRows();
            }
            // Allow selection events again after re-select is applied
            this.gridSuppressSelectionEvents = false;
          });
          // Close spinner only after data is assigned and a paint tick (if closeSpinner is true)
          if (closeSpinner && this.dialogRefSpinner) {
            this.cdRef.detectChanges();
            requestAnimationFrame(() => {
              this.dialogRefSpinner?.close();
            });
          }
        },
        error: (error) => {
          console.error('Error loading rows:', error);
          if (closeSpinner) {
            this.dialogRefSpinner?.close();
          }
        }
      }
      )
  }

//LLAMADAS PARA ACTUALIZAR LOS DATOS DEL GRID
  reloadData(origen?: string){
    this.currentPage = 1;
    this.centros = [];
    this.hasMoreRows = true;
    // this.centrosFiltradosInput = []; // Reset filtered rows when reloading data
    this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
    this.getCentros('reloadData');
  }

  loadRows(){
    if(this.isLoading || !this.hasMoreRows) return; // Prevent duplicate requests
    else{
      // this.centrosFiltradosInput = [];
      this.gridSuppressSelectionEvents = true;
      this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
      this.getCentros('scroll');
    }
  }

  loadRowsWithoutSpinner(){
    if(this.isLoading || !this.hasMoreRows) return;
    else{
      // this.centrosFiltradosInput = [];
      this.gridSuppressSelectionEvents = true;
      this.getCentros('scroll', false); // Don't close spinner
    }
  }

  ordenarGrid(event: OrdenColumna){
    this.ordenColumna = event;
    this.reloadData();
  }
//FIN LLAMADAS PARA ACTUALIZAR LOS DATOS DEL GRID

//ACCIONES EDITAR/ELIMINAR/CREAR NUEVO CENTRO
  creaNuevoCentro(){
    let info: any = {};
    info.centro={
      codigoCentro:'',
      nombreCentro:'',
      emailCentro:'',
      codigoEmpresa: '',
      nombreEmpresa: ''
    }
    info.nuevo = true;
    info.empresas = this.empresas;
    info.centros = this.centros;
    const dialogRef = this.dialog.open(CentrosModalComponent, {
      data: info,
      panelClass: 'modal-class-detalle',
      position: { right: '0'}
    });

    dialogRef.afterClosed().subscribe(result=>{
      if(result === 'OK'){
        this.reloadData();

      }
    })
  }

  abreModal(centro:any){
    let info: any = {};
    info.centro = centro.data;
    info.centros = this.centros;
    info.empresas = this.empresas;
    info.nuevo = false;
    const dialogRef = this.dialog.open(CentrosModalComponent, {
      data: info,
      panelClass: 'modal-class-detalle',
      position: { right: '0'}
    });

    // Store the row information and scroll position
    const editedRowId = centro.data.codigoCentro;
    const rowIndex = centro.rowIndex;
    const initialCurrentPage = this.currentPage;

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'OK') {
        // Reload data and maintain scroll position
        this.reloadDataAndMaintainScroll(editedRowId, rowIndex, initialCurrentPage);
      }
    });
  }

  private reloadDataAndMaintainScroll(editedRowId: string, originalRowIndex: number, targetPage: number) {
    // Store current scroll position
    const scrollTop = this.sqpGrid.api.getVerticalPixelRange()?.top || 0;

    // Clear and reload data
    this.centros = [];
    this.currentPage = 1;
    this.hasMoreRows = true;
    // this.centrosFiltradosInput = [];
    this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);

    // Load data up to the target page to maintain the same data context
    this.loadDataUpToPage(targetPage, editedRowId, originalRowIndex, scrollTop);
  }

  private loadDataUpToPage(targetPage: number, editedRowId: string, originalRowIndex: number, scrollTop: number) {
    if (this.isLoading || !this.hasMoreRows || this.currentPage > targetPage) {
      // All data loaded, now restore scroll
      this.restoreScrollAndSelectRow(editedRowId, originalRowIndex, scrollTop);
      return;
    }

    this.isLoading = true;
    this.datosCentrosService.getCentros(this.filtros, this.currentPage, this.ordenColumna).subscribe({
      next: (response: CentrosModel[]) => {

        this.centros = [...this.centros,...response];
        this.currentPage++;
        const returnedRowCount = response.length;
        if (returnedRowCount < 50) this.hasMoreRows = false;
        else this.hasMoreRows = true;

        this.isLoading = false;

        // Continue loading if we haven't reached the target page and there are more rows
        if (this.currentPage <= targetPage && this.hasMoreRows) {
          this.loadDataUpToPage(targetPage, editedRowId, originalRowIndex, scrollTop);
        } else {
          this.restoreScrollAndSelectRow(editedRowId, originalRowIndex, scrollTop);
        }
      },
      error: (error) => {
        console.error('Error loading rows:', error);
        this.isLoading = false;
        this.restoreScrollAndSelectRow(editedRowId, originalRowIndex, scrollTop);
      }
    });
  }

  private restoreScrollAndSelectRow(editedRowId: string, originalRowIndex: number, scrollTop: number) {

    // Wait for the grid to render the data
    this.cdRef.detectChanges();
    requestAnimationFrame(() => {
      // Find the edited row and focus on the first editable cell
      this.sqpGrid.api.forEachNodeAfterFilter((node: any) => {
        if (node.data.codigoCentro === editedRowId) {
          // Ensure the row is visible
          this.sqpGrid.api.ensureNodeVisible(node);

          // Focus on the first editable cell
          const columnToFocus = 'nombreCentro';
          this.sqpGrid.api.setFocusedCell(node.rowIndex, columnToFocus);
        }
      });

      if (this.dialogRefSpinner) {
        this.dialogRefSpinner.close();
      }
    });
  }

  eliminarCentro(){
    const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
      data: {
        tipo: TipoMensajeConfirmacion.ConfirmacionCompleja,
        icono: 'icon-delete',
        titulo: this.centrosSeleccionados.length>1? '¿Eliminar centros?':'¿Eliminar centro?',
        // preguntaConfirmacion: '¿Eliminar centro?',
        textoConfirmacion: this.centrosSeleccionados.length>1?'Eliminar los centros seleccionados':'Eliminar el centro seleccionado',
        textoBoton: 'Eliminar',
        iconoConfirmacion: 'icon-delete'
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result === 'OK'){
        const dialogRefSpinner = this.dialog.open(SpinnerModalComponent);
        let count: number = 0;
        this.centrosSeleccionados.forEach(x=>{
          this.datosCentrosService.deleteCentro(x).subscribe(
            next => {
              count++;
              if(this.centrosSeleccionados.length == count){
                dialogRefSpinner.close();
                const dialogRef = this.dialog.open(ModalMessageComponent, {
                  data: {
                    mensaje: this.centrosSeleccionados.length==1 ? 'Centro eliminado correctamente':'Centros eliminados correctamente',
                  },
                });
                // this.dialogRef.close('OK');
                // this.datosCentrosService.refreshCentros = true;
                this.reloadData();
              }

            },
            error => {
              dialogRefSpinner.close();
              console.error("error", error);
              const dialogRef = this.dialog.open(ModalMessageComponent, {
                data: {
                  mensaje: this.centrosSeleccionados.length==1 ? 'Error. El centro no se ha eliminado':'Error. Los centros no se han eliminado',
                  alert: true
                },
              });
              // this.dialogRef.close();
            }
          );
        })

      }
    })
  }
//FIN ACCIONES EDITAR/ELIMINAR/CREAR NUEVO CENTRO

  clickBarraSuperior(id: string){
    this.mostrarSubidaExcel = false;
    switch (id) {
      case 'Excel-download':
        this.exportaExcel();
        break;
      case 'Excel-upload':
        this.mostrarSubidaExcel = true;
        break;
      case "Pdf":
        this.exportaPdf();
        break;
      default:
        break;
    }
  }

  onCentrosUploadGuardado(): void {
    this.mostrarSubidaExcel = false;
    this.reloadData();
  }



//FILTRAR CENTROS
  buscarCentros(textoBuscar:string){
    if(this.centros){
      this.filtros[0].textoBuscar = textoBuscar;
      this.filtros[0].text = 'Buscar';
      this.filtros[0].value = textoBuscar;
      this.reloadData('buscar');
      // if(textoBuscar == '') this.reloadData('buscar');
      // else{
      //   if (this.searchTimeout) clearTimeout(this.searchTimeout);
      //   this.searchTimeout = setTimeout(() => {
      //     this.reloadData('buscar');
      //   }, 2000);
      // }
    }
  }

  // quitarFiltro(filtro: FiltroBasico){
  //   // this.datosCentrosService.deleteFilter(filtro);
  //   // this.datosCentrosService.Filter();
  //   // this.centros = this.datosCentrosService.centrosFiltrados;
  //   // this.barrSuperior.buscarTexto('');
  // }
//FIN FILTRAR CENTROS

//SELECCIONAR/DESELECCIONAR CENTROS
  seleccionCentros(event: CentrosModel[]){
    this.centrosSeleccionados = event;
    if(this.centrosSeleccionados.length > 1) this.textoBorrar = `${event.length} centros seleccionados`;
    else this.textoBorrar = `${event.length} centro seleccionado`;
  }

  deseleccionarAll(){
    this.sqpGrid.api.deselectAll();
  }

  selectPreviouslySelectedRows() {
    this.paginationHelper.selectPreviouslySelectedRows(
      this.sqpGrid.api,
      {
        selectedItems: this.centrosSeleccionados,
        identifierField: 'codigoCentro'
      }
    );
  }

  selectAllRowsInGrid() {
    this.sqpGrid.api.forEachNodeAfterFilter((node:any) => {
      node.setSelected(true);
    });
  }

  onHeaderSelectionToggled(allSelected: boolean){
    if (allSelected) {
      if(this.hasMoreRows){
        const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
          data: {
            tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
            titulo: 'Seleccionar todos los registros',
            mensaje: '<p>Para seleccionar todos los registros se tienen que descargar todos los datos, el proceso puede tardar más de lo habitual. ¿Desea continuar?</p>',
            textoConfirmacion: 'Seleccionar todos',
            textoCancelar: 'cancelar'
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          if(result === 'OK'){
            // Show spinner and load all remaining rows when "select all" is clicked
            this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
            // Don't select rows yet, just load all data first
            this.loadAllRemainingRows();
          }
        });
      }else{ //no preguntamos ya que toda la data ya está cargada
        this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
        this.loadAllRemainingRows();
      }

    } else {
      // Update selection text and backup for deselect all
      this.centrosSeleccionados = [];
    }
  }

  private loadAllRemainingRows() {
    if (this.isLoading || !this.hasMoreRows) {
      // All rows loaded, now select all and paint them
      this.centrosSeleccionados = [...this.centros];
      this.textoBorrar = `${this.centrosSeleccionados.length} centros seleccionados`;

      // Select all rows in the grid and paint them blue
      this.cdRef.detectChanges();
      requestAnimationFrame(() => {
        this.selectAllRowsInGrid();
        // Close spinner after selection is complete
        if (this.dialogRefSpinner) {
          this.dialogRefSpinner.close();
        }
      });
      return;
    }

    // Load next batch of rows (without showing spinner since we already have one)
    this.loadRowsWithoutSpinner();

    // After loading, check if we need to load more
    setTimeout(() => {
      this.loadAllRemainingRows();
    }, 1000);
  }

//FIN SELECCIONAR/DESELECCIONAR CENTROS

  getEmpresas(){
    this.datosEmpresasService.getEmpresas([],0).subscribe({
      next: (response: any) => {
        this.empresas=response;
      },
      error: (error) => {
        console.error('Error loading rows:', error);
      }
    })
  }

//EXPORTAR PDF/EXCEL
  exportaPdf(){
    if(this.centros){
      const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
        data: {
          tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
          icono: 'icon-pdf-empty',
          titulo: 'Generar PDF',
          mensaje: 'Genera un documento PDF con la información de los registros mostrados en el listado',
          textoConfirmacion: 'Generar PDF',
          iconoConfirmacion: 'icon-pdf-empty',
          textoCancelar: 'cancelar'
        }
      });

      //montamos el objeto a pasar al servicio con el modelo DatosPdf
      const datos = this.montarParametrosPdf()

      dialogRef.afterClosed().subscribe(result => {
        if(result === 'OK'){
          if(this.hasMoreRows){
            this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
            this.datosCentrosService.getCentros(this.filtros, 0).subscribe({
              next: (response: any) => {
                this.centros=response;
                this.exportadorPdfService.exportaPdf(datos, this.centros);
                this.dialogRefSpinner.close();
              },
              error: (error) => {
                console.error('Error loading rows:', error);
                this.dialogRefSpinner.close();
              }
            })
          }else{
            this.exportadorPdfService.exportaPdf(datos, this.centros);
          }
        }
      });
    }
  }

  montarParametrosPdf(): DatosPdf{
    let columns: any [] = [];
    this.columnDefs.forEach( x => {
      columns.push( {header: x.headerName, dataKey: x.field} )
    })
    let fecha = new Date();
    let datosPdf = {
      landscape: true,
      nombreFichero:`Hire&Sign_centros_${fecha.getFullYear()}${fecha.getMonth()+1}${fecha.getDate()}${fecha.getHours()}${fecha.getMinutes()}${fecha.getSeconds()}.pdf`,
      registros: columns
    }
    return datosPdf
  }

  exportaExcel(){
    if(this.centros){
      const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
        data: {
          tipo: TipoMensajeConfirmacion.ConfirmacionSimple,
          icono: 'icon-excel-empty',
          titulo: 'Generar excel',
          mensaje: 'Genera un documento Excel con la información de los registros mostrados en el listado',
          textoConfirmacion: 'Generar excel',
          iconoConfirmacion: 'icon-excel-empty',
          textoCancelar: 'cancelar'
        }
      });

      let datosExcel = this.montarParametrosExcel();

      dialogRef.afterClosed().subscribe(result => {
        if(result === 'OK'){
          if(this.hasMoreRows){
            this.dialogRefSpinner = this.dialog.open(SpinnerModalSqpComponent);
            this.datosCentrosService.getCentros(this.filtros, 0).subscribe({
              next: (response: any) => {
                this.centros=response;
                let rows = this.GetRows(this.centros);
                this.exportadorExcelService.exportaExcel(datosExcel, rows);
                this.dialogRefSpinner.close();
                this.hasMoreRows = false;
              },
              error: (error) => {
                console.error('Error loading rows:', error);
                this.dialogRefSpinner.close();
              }
            })
          }else{
            let rows = this.GetRows(this.centros);
            this.exportadorExcelService.exportaExcel(datosExcel, rows);
          }
        }
      });
    }
  }

  montarParametrosExcel(): DatosExcel{
    let fecha = new Date();
    let datosExcel = {
      workSheetName:'Centros',
      nombreFichero:`Hire&Sign_centros_${fecha.getFullYear()}${fecha.getMonth()+1}${fecha.getDate()}${fecha.getHours()}${fecha.getMinutes()}${fecha.getSeconds()}.xlsx`,
      columnas: this.GetColumns()
    }
    return datosExcel
  }

  //Generamos las columnas basandonos en las del grid
  GetColumns(): any[]{
    let columns:any[] = [];
    this.columnDefs.forEach( x => {
        let element:any = {};
        element.name = x.headerName;
        element.filterButton = true;
        element.width = x.width;
        columns.push(element);
    });
    return columns;
  }

  // Mapeamos los datos de los centros a las filas del excel
  GetRows(data:CentrosModel[]):any[]{
    let rows:any[] = [];
    data.forEach(x=>{
      let row:any[] =
      [
        x.nombreCentro,
        x.emailCentro,
        x.codigoCentro,
        x.codigoEmpresa,
        x.nombreEmpresa,
        x.nombreRlt,
        x.dniRlt
      ];
      rows.push(row);
    });
    return rows
  }

//FIN EXPORTAR PDF/EXCEL
}
